// extracted by mini-css-extract-plugin
export default {"CardTile":"CardTile_CardTile__Dk7Go","card-img":"CardTile_card-img__5BiU4"};